/** Format a Date as YYYY-MM-DD in the browser's local timezone. */
export const toLocalIsoDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/** Today's date as YYYY-MM-DD in the browser's local timezone. */
export const todayLocalIso = () => toLocalIsoDate(new Date());

/** Subtract days from today and return YYYY-MM-DD in the browser's local timezone. */
export const daysAgoLocalIso = (days: number): string => {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return toLocalIsoDate(d);
};

/** Add days to a YYYY-MM-DD string, keeping the result in local calendar days. */
export const addDaysToIsoDate = (dateStr: string, days: number): string => {
  const d = new Date(`${dateStr}T00:00:00`);
  d.setDate(d.getDate() + days);
  return toLocalIsoDate(d);
};
